<template>
  <v-card
      elevation="2"
      id="search"
      class="mx-auto my-12 pa-10"
      max-width="1100"
  >
    <div class="text-left">
      <h2 class="text-center">
        {{ 'Search result for ' }} {{ ` "${$route.query.search}"` }}
      </h2>
      <div>
        <v-progress-linear
            v-if="loading"
            class="mt-5"
            indeterminate
            color="black"
        ></v-progress-linear>
        <VueMarkdown
            id="scrollTabsContainer1"
            class="scrollTabsContainer text-left d-none"
            :source="someMarkdownText"
            :toc="true"
            :watches="sources"
            :toc-first-level="2"
            :toc-last-level="4"
            :toc-anchor-link-symbol="''"
            :toc-anchor-link-class="'v-list-active'"
            @rendered="rendered"
            :postrender="postrender"
            toc-id="table-of-content"
        ></VueMarkdown>
        <div v-if="!loading">
          <div v-for="k in keys" :key="k.link"
          >
            <a
                @click="goToContent(k.link)"
                class="text-decoration-none hover--link" style="font-size: 22px">{{ k.text }}
            </a>
            <div v-html="k.preview" class="mt-1 mb-4 text--black text-truncate"></div>
            <v-divider class="mb-4"/>
          </div>
          <div v-if="!keys.length">
            <p> {{ 'No matching results found' }}</p>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import MSuiteUserGuide from '@/views/user-guide/M-Suite-UserPortalandAgent-Guide.md';
import MSuiteTroubleshooting from '@/views/user-guide/M-Suite-Troubleshooting-Guide.md';
import MSuiteTroubleshootBaselineFix from '@/views/user-guide/M-Suite-Troubleshooting-Baseline-Fix.md';
import VueMarkdown from "vue-markdown";

export default {
  name: "Search",
  watchQuery: false,
  components: {
    VueMarkdown,
  },
  watch: {
    "$route": {
      async handler() {
        setTimeout(() => {
          this.loading = false
        }, 500)
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      someMarkdownText: '',
      sources: ["source", "show", "toc"],
      keys: [],
      loading: true
    }
  },
  methods: {
    getData(query) {
      if (query && query.search) {
        return query.search.toLowerCase()
      }
      return ''
    },

    rendered(html) {
      return html
    },
    goToContent(hash) {
      if (!hash) {
        return
      }
      this.$router.push({'path': '/user-guide/index', 'hash': hash, 'query': {focusContent: true}})
    },
    checkArray(arr) {
      return !!(arr && Array.isArray(arr) && arr.length);
    },
    postrender(html) {
      this.loading = true
      this.keys = []
      const htmlObject = document.createElement('div');
      htmlObject.innerHTML = html;
      const search = this.getData(this.$route.query)
      const childrenEls = htmlObject.children;
      let lastKey = ''
      let lastText = ''
      const keyItems = []
      for (const childrenEl of childrenEls) {
        if (childrenEl.id) {
          lastKey = childrenEl.id
          lastText = childrenEl.innerText
        }
        if (childrenEl.textContent.toLowerCase().includes(search)) {
          childrenEl.innerText = childrenEl.innerText.toLowerCase().replace(search.toLowerCase(), `<span class="font-weight-bold">${search}</span>`)
          keyItems.push({
            link: lastKey,
            text: lastText,
            preview: childrenEl.innerText
          })
        }
      }
      this.keys = keyItems.filter((value, index, self) =>
              index === self.findIndex((t) => (
                  t.link === value.link
              ))
      )
      return html
    },

    renderHtml() {
      this.someMarkdownText = MSuiteUserGuide + MSuiteTroubleshooting + MSuiteTroubleshootBaselineFix
    },
  },
  created() {
    this.renderHtml()
  },
  mounted() {
  },
}
</script>
<style lang="scss">
#search {
  a {
    color: #1a0dab !important;
  }

  a:visited {
    color: #571c79 !important;
  }

  #scrollTabsContainer1 {
    img {
      max-width: 100%;
      margin-bottom: 24px;
      margin-top: 24px;
    }

    h1, h2, h3, h4 {
      font-size: 24px !important;
      margin-bottom: 24px;
    }
  }

  #scrollTabsContainer {
    img {
      max-width: 100%;
    }
  }

  .hover--link {
    &:hover {
      text-decoration: underline !important;
    }
  }
}
</style>
